import { ErklaerungLayout } from './ErklaerungLayout';
import type { ErklaerungApiError } from '@/types/erklaerung';

interface Props {
  error: ErklaerungApiError;
}

const CONTACT_EMAIL = 'studienbuero@fom.de';

export function ErklaerungErrorPage({ error }: Props) {
  let title = 'Ein Fehler ist aufgetreten';
  let message = 'Bitte versuchen Sie es später erneut oder kontaktieren Sie die FOM.';

  if (error.code === 'not_found') {
    title = 'Link ungültig';
    message = 'Der Link ist ungültig. Bitte überprüfen Sie die URL oder kontaktieren Sie die FOM.';
  } else if (error.code === 'expired') {
    title = 'Link abgelaufen';
    message = 'Der Link ist abgelaufen. Bitte kontaktieren Sie die FOM für einen neuen Link.';
  } else if (error.code === 'locked') {
    const until = error.until
      ? new Date(error.until).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' })
      : 'später';
    title = 'Zu viele Fehlversuche';
    message = `Dieser Link ist vorübergehend gesperrt. Bitte versuchen Sie es ab ${until} erneut. Bei Fragen: ${CONTACT_EMAIL}.`;
  }

  return (
    <ErklaerungLayout>
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-6">
          <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-3">{title}</h1>
        <p className="text-slate-600 max-w-md">{message}</p>
        <p className="mt-6 text-sm text-slate-500">
          Bei weiteren Fragen wenden Sie sich an{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-teal-600 underline">
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </ErklaerungLayout>
  );
}
